import { getFormatter } from '../Insights/KPI/utils'
import { setAxisTheme } from './optionUtils'

const axisNameFormatter = (axisName) => {
    return axisName.split('/').join('\n')
}

const getDefaultAxisPosition = (index, seriesType) => {
    if (seriesType === 'bar') return index === 0 ? 'top' : 'bottom'
    return index === 0 ? 'left' : 'right'
}

const convertBarPosition = (position) => {
    const barPositionMap = {
        left: 'top',
        right: 'bottom',
    }
    return barPositionMap[position] || position
}

const applyAxisPositioning = (chartAxis, position, seriesType, index) => {
    const finalPosition = seriesType === 'bar' ? convertBarPosition(position) : position
    chartAxis.position = finalPosition
    if (seriesType === 'bar') {
        chartAxis.axisLabel.align = finalPosition === 'bottom' ? 'top' : 'bottom'
    } else {
        chartAxis.axisLabel.align = finalPosition === 'right' ? 'left' : 'right'
    }
    if (index > 1) {
        chartAxis.offset = 80 * (index - 1)
    }
}

const determineAxisPosition = (axis, index, seriesType, summaryConfig) => {
    if (summaryConfig.metricsOrder.length > 0) {
        const metricConfig = summaryConfig.metricsOrder.find((metric) => {
            if (axis.name.includes('/')) {
                const [part1, part2] = axis.name.split('/').map((part) => part.trim())
                return metric.name.includes(part1) && metric.name.includes(part2)
            }
            return metric.name === axis.name
        })
        return metricConfig?.position || getDefaultAxisPosition(index, seriesType)
    }
    return getDefaultAxisPosition(index, seriesType)
}

export const parseValueAxis = (summaryData, summaryConfig) => {
    return (
        summaryData.axes?.map((axis, index) => {
            const chartAxis = {
                name: axis.name ? axisNameFormatter(axis.name) : undefined,
                type: 'value',
                alignTicks: true,
                axisLabel: {
                    formatter: (val) => getFormatter(axis.format).format(val),
                },
            }
            if (summaryConfig.seriesType === 'scatter') return chartAxis
            const position = determineAxisPosition(
                axis,
                index,
                summaryConfig.seriesType,
                summaryConfig
            )
            applyAxisPositioning(chartAxis, position, summaryConfig.seriesType, index)
            return chartAxis
        }) || []
    )
}

export const parseCategoryAxis = (summaryData, summaryConfig) => {
    let categoryAxis = { type: 'category' }
    if (summaryConfig.categoryAxis === 'Time') categoryAxis.data = summaryData.dates
    else categoryAxis.data = summaryData.categoryAxisValues
    return categoryAxis
}

export const assignAxisToOption = (
    option,
    summaryConfig,
    summaryData,
    valueAxis,
    categoryAxis,
    theme
) => {
    switch (summaryConfig.seriesType) {
        case 'bar':
            option.xAxis = valueAxis
            option.yAxis = [categoryAxis]
            break
        case 'scatter':
            if (valueAxis[0].name === summaryData.metrics[0].name) {
                option.yAxis = [valueAxis[valueAxis?.length === 1 ? 0 : 1]]
                option.xAxis = [valueAxis[0]]
            } else if (valueAxis.length === 1) {
                option.yAxis = [valueAxis[0]]
                option.xAxis = [valueAxis[0]]
            } else {
                option.yAxis = [valueAxis[0]]
                option.xAxis = [valueAxis[1]]
            }
            option.xAxis[0].position = 'bottom'
            option.yAxis[0].position = 'left'
            break
        case 'heatmap':
            option.xAxis = [
                {
                    type: 'category',
                    data: summaryData.categoryAxisValues,
                    splitArea: { show: true },
                },
            ]
            option.yAxis = [
                {
                    type: 'category',
                    data: summaryData.categories,
                    splitArea: { show: true },
                },
            ]
            break
        default:
            option.xAxis = [categoryAxis]
            option.yAxis = valueAxis
            break
    }
    const axisColor = theme?.colorScheme?.darkTheme ? '#FFFFFF' : '#6E7079'
    option.xAxis.forEach((axis) => {
        if (axis) setAxisTheme(axis, axisColor)
    })
    option.yAxis.forEach((axis) => {
        if (axis) setAxisTheme(axis, axisColor)
    })
}
